<template>
  <v-card flat>
    <FormField label="Nome da Forma de Entrega" v-model="form.nomeForma" />
    <FormField
      label="CNPJ"
      v-model="form.freteRapido.cnpj"
      typeField="text"
      mask="XX.XXX.XXX/XXXX-XX"
    />
    <FormField label="Token da api" v-model="form.freteRapido.token" />
    <FormField
      label="Código da plataforma"
      v-model="form.freteRapido.platformCode"
    />
    <FormField
      label="Custo de separação"
      :money="form.freteRapido.acrescimoTaxa === null ? null : moneyMask"
      v-model="form.freteRapido.acrescimoTaxa"
    />
    <FormField
      label="Tempo de preparo e despacho em dias"
      v-model="form.freteRapido.diasSeparacao"
      typeField="number"
    />
    <FormField
      label="CEP de origem"
      v-model="form.freteRapido.cepOrigem"
      typeField="number"
      mask="#####-###"
    />
    <FormAutocomplete
      label="Selecione o layout de etiqueta"
      v-model="form.freteRapido.layoutEtiqueta"
      :options="opcoesLayout"
      class="mt-3"
    />
    <FormAutocomplete
      label="Selecione o formato de etiqueta"
      v-model="form.freteRapido.formatoEtiqueta"
      :options="opcoesFormato"
      class="mt-3"
    />
    <h4 class="text-center">Parâmetros de volume</h4>
    <LineDivider></LineDivider>
    <v-row no-gutters class="mt-n6 mb-4">
      <v-col cols="auto">
        <FormSwitch v-model="form.freteRapido.consolidate" label="Consolidar" />
      </v-col>
      <v-col cols="auto" class="ml-8">
        <FormSwitch v-model="form.freteRapido.overlaid" label="Sobrepor" />
      </v-col>
      <v-col cols="auto" class="ml-8">
        <FormSwitch v-model="form.freteRapido.rotate" label="Rotacionar" />
      </v-col>
    </v-row>
    <h4 class="text-center">Transportadoras</h4>
    <LineDivider></LineDivider>
    <v-row>
      <v-col cols="12" md="3">
        <FormField label="Nome" v-model="transportadora.nome" />
      </v-col>
      <v-col cols="12" md="3">
        <FormField
          label="Código Frete Rápido"
          v-model="transportadora.codigoHub"
        />
      </v-col>
      <v-col cols="12" md="3">
        <FormField label="Código ERP" v-model="transportadora.codigoErp" />
      </v-col>
      <v-col cols="12" md="3">
        <FormButton
          text="Adicionar"
          @click="addTransportadora"
          :disabled="
            !transportadora.nome ||
              !transportadora.codigoHub ||
              !transportadora.codigoErp
          "
        />
      </v-col>
      <v-col cols="12" v-if="form.freteRapido.transportadoras.length > 0">
        <v-simple-table responsive>
          <thead>
            <tr>
              <th class="text-center">Nome</th>
              <th class="text-center">Código Frete Rápido</th>
              <th class="text-center">Código ERP</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in form.freteRapido.transportadoras" :key="i">
              <td class="text-center">{{ item.nome }}</td>
              <td class="text-center">{{ item.codigoHub }}</td>
              <td class="text-center">{{ item.codigoErp }}</td>
              <td class="text-center">
                <FormButton
                  text="Excluir"
                  type="error"
                  @click="deleteTransportadora(i)"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import FormField from "@/components/form/FormField";
import LineDivider from "@/components/LineDivider";
import FormButton from "@/components/form/FormButton";
import FormSwitch from "@/components/form/FormSwitch";
import FormAutocomplete from "@/components/form/FormAutocomplete";
import {
  OPCOESLAYOUTFRETERAPIDO,
  OPCOESFORMATOFRETERAPIDO
} from "@/store/actions/formasEntrega";

export default {
  name: "FormaEntregaFormFreteRapido",
  components: {
    FormField,
    LineDivider,
    FormButton,
    FormSwitch,
    FormAutocomplete
  },
  props: {
    data: {
      type: [Object],
      default: () => ({}),
      required: true
    }
  },
  data() {
    return {
      moneyMask: {
        decimal: ",",
        thousands: " ",
        prefix: "",
        suffix: "",
        default: "",
        precision: 2,
        masked: false
      },
      transportadora: {},
      form: {},
      opcoesLayout: OPCOESLAYOUTFRETERAPIDO,
      opcoesFormato: OPCOESFORMATOFRETERAPIDO
    };
  },
  methods: {
    addTransportadora() {
      this.form.freteRapido.transportadoras.push(this.transportadora);
      this.transportadora = {};
      this.update();
    },
    deleteTransportadora(i) {
      this.form.freteRapido.transportadoras.splice(i, 1);
      this.update();
    },
    update() {
      this.$emit("update", this.form);
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit("update", this.form);
      }
    }
  },
  created() {
    this.form = this.data;
  }
};
</script>
